webpackJsonp([89684000601253],{

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic08.c55eca59.jpg";

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic09.e1b5f8a3.jpg";

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BannerLanding = function BannerLanding(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "banner", className: "style2" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "header",
	                { className: "major" },
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Architectural Descriptions of Farm Structures"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "content" },
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "This is the landing page for architectural information - Check back soon!"
	                )
	            )
	        )
	    );
	};
	
	exports.default = BannerLanding;
	module.exports = exports["default"];

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _BannerLanding = __webpack_require__(214);
	
	var _BannerLanding2 = _interopRequireDefault(_BannerLanding);
	
	var _pic = __webpack_require__(133);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _pic3 = __webpack_require__(134);
	
	var _pic4 = _interopRequireDefault(_pic3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Landing = function Landing(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'Architecture - Sunny Crest'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'Landing Page' })
	        ),
	        _react2.default.createElement(_BannerLanding2.default, null),
	        _react2.default.createElement(
	            'div',
	            { style: { margin: "3rem auto", maxWidth: 600, "font-family": "Times New Roman" }, id: 'main' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Individual architectural descriptions will be here'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'For over a hundred years, Sunny Crest was owned by a succession of members of the Portteus family.  The brick Craftsman Foursquare was built by Josiah Lowes and Stella Shonkwiler Portteus in 1915.  When they built it, they moved the original house on the property about fifty yards west, and converted into a shop and garage.  Today most of the farm structures remain.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { id: 'two', className: 'spotlights' },
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/#', className: 'image' },
	                        _react2.default.createElement('img', { src: _pic2.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inner' },
	                            _react2.default.createElement(
	                                'header',
	                                { className: 'major' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'Fancy ridge cap preserved'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'The original roof on the house was slate.  For unknown reasons, it failed and was replaced in the 1980s.  The fancy dentillated ridge cap was preserved, and placed over the shingled ridge.'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/#', className: 'image' },
	                        _react2.default.createElement('img', { src: _pic4.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inner' },
	                            _react2.default.createElement(
	                                'header',
	                                { className: 'major' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'Hand-painted plaster walls!'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'The plaster walls of the main room were painted by local artisans, the Diedams.  The walls were refurbished ahead of Josiah and Stella Portteus\'s 50th wedding anniversary in 1946.'
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'actions' },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _gatsbyLink2.default,
	                                        { to: '/mission', className: 'button' },
	                                        'Our mission'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Landing;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-arch-js-0766f37a71672e544704.js